<template>
  <el-dialog
    :visible.sync="showOpenAudioDialog"
    class="comp-container"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escap="false"
  >
    <div class="tips">
      {{ "老师希望你解除静音" }}
    </div>
    <div class="footer">
      <el-button @click="onClickOpenAudio(false)">
        {{ "保持静音" }}
      </el-button>
      <el-button type="primary" @click="onClickOpenAudio(true)">
        {{ "解除静音" }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("live", [
      "showOpenAudioDialog",
      "audioPermission",
      "userStatus",
    ]),
  },
  methods: {
    ...mapMutations("live", ["setShowOpenAudioDialog", "setUserStatus"]),
    onClickOpenAudio(type) {
      if (type) {
        if (!this.audioPermission) {
          this.$darkMessage.error("打开系统权限后重试");
          uploadLiveLog({
            message: "打开系统权限后重试",
            level: "error",
            extra: {
              component: "OpenAudio",
              action: "onClickOpenAudio",
              type: "false",
            },
          });
          return;
        }
        // TODO 先判断权限是否开启，r
        // if (this.userStatus.is_up_stage !== 1) {
        //   this.$darkMessage.error("上台后，才能开启音视频功能");
        //   return;
        // }
        // if (this.userStatus.is_send_audio !== 1) {
        //   this.$darkMessage.error("你被老师禁止打开麦克风");
        //   return;
        // }
        this.setUserStatus({
          audio_state: 1,
          is_send_audio: 1,
          is_up_stage: 1,
        });
        this.setShowOpenAudioDialog(false);
        this.$darkMessage.success("你可以自由发言");
        uploadLiveLog({
          message: "你可以自由发言",
          level: "info",
          extra: {
            component: "OpenAudio",
            action: "onClickOpenAudio",
          },
        });
      } else {
        this.setUserStatus({
          audio_state: 2,
          is_send_audio: 1,
          is_up_stage: 1,
          update: Date.now(),
        });
        this.setShowOpenAudioDialog(false);
        this.$darkMessage.error("麦克风已关闭，无法发言");
        uploadLiveLog({
          message: "麦克风已关闭，无法发言",
          level: "error",
          extra: {
            component: "OpenAudio",
            action: "onClickOpenAudio",
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #a1a1aa;

      text-align: center;
      .tips {
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 20px;
      }
      .el-checkbox {
        margin-top: 8px;
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #165dff;
            border-color: #165dff;
          }
        }
        .el-checkbox__inner {
          border-color: #165dff !important;
          &:hover {
            border-color: #165dff;
          }
        }
        .el-checkbox__label {
          color: #a1a1aa;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover,
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
